// Fridge.com Brand Kit — Reusable Component Library
// See docs/Design.md for full documentation

// Cards
export { BadgePill, type BadgeVariant } from "./badge-pill"
export { QuickSpecCard } from "./quick-spec-card"
export { InfoCard } from "./info-card"
export { OffersCard } from "./offers-card"
export { ExpertVerdictCard } from "./expert-verdict-card"
export { KeyFeaturesCard } from "./key-features-card"
export { TechSpecsCard } from "./tech-specs-card"
export { ProductCarouselCard, type CarouselProduct } from "./product-carousel-card"
export { RecentlyViewedCarousel, type RecentlyViewedItem } from "./recently-viewed-carousel"
export { RecentlyViewedRail } from "./recently-viewed-rail"
export { BackToTopButton } from "./back-to-top-button"
export { DarkCallout } from "./dark-callout"
export {
  LocationStatCard,
  type LocationStatCardProps,
  type LocationStatTile,
  type LocationStatTileTone,
} from "./location-stat-card"
export { FeaturedStoryCard, type FeaturedStoryArticle } from "./featured-story-card"
export { TrendingList, type TrendingListItem } from "./trending-list"
export { InlineProductCard } from "./inline-product-card"
export {
  InlineCollectionBand,
  type InlineCollectionBandData,
  type InlineCollectionBandProduct,
} from "./inline-collection-band"
export { ComparisonTable, FeatureComparisonTable } from "./comparison-table"
export type { ComparisonRow, ComparisonTableProps, FeatureComparisonProps } from "./comparison-table"
export { NumberedSteps } from "./numbered-steps"
export { FAQTinted } from "./faq-tinted"
export { FeatureCard } from "./feature-card"
export { ArticleCard } from "./article-card"
export { BrandFeatureCard } from "./brand-feature-card"
export { ToolLinkCard } from "./tool-link-card"
export { BrandListCard } from "./brand-list-card"
export { CategoryHeroCard } from "./category-hero-card"
export { CategoryCard } from "./category-card"
export { ConsiderationCard } from "./consideration-card"
export { CTABanner } from "./cta-banner"
export { CompatibleFilterCard, type CompatibleFilterItem } from "./compatible-filter-card"

// Page-Level Components
export { HeroBanner } from "./hero-banner"
export { CenteredHero } from "./centered-hero"
export { CategoryLinkGroup } from "./category-link-group"

// Interactive Components
export { FAQAccordion } from "./faq-accordion"
export { ImageGallery } from "./image-gallery"
export { HorizontalCarousel } from "./horizontal-carousel"
export { ScrollCarousel } from "./scroll-carousel"
export { BrandLogoGrid } from "./brand-logo-grid"
export { Pagination } from "./pagination"
export { SearchInput } from "./search-input"
export { TogglePillGroup } from "./toggle-pill-group"

// Micro Components (Atoms)
export { SectionHeader } from "./section-header"
export { PageSectionHeader } from "./page-section-header"
export { IndexSectionHeader } from "./index-section-header"
export { StarRating } from "./star-rating"
export { Breadcrumb } from "./breadcrumb"
export { BrandRatingLine } from "./brand-rating-line"
export { FilterPill } from "./filter-pill"
export { CategoryFilterPill } from "./category-filter-pill"
export { ShowMoreButton } from "./show-more-button"

// Editorial Layout Blocks (used on index/landing pages)
export { StatBorderGrid, type StatBorderGridItem } from "./stat-border-grid"
export { FeaturedAccentCard } from "./featured-accent-card"
export { NumberedStepList, type NumberedStep } from "./numbered-step-list"

// Tool Page Variants (shipped with the 2026-04-23 redesign of 89 tool pages)
export { EditorialHero } from "./editorial-hero"
export { SectionRule } from "./section-rule"
export { RelatedToolsRail, type RelatedToolItem } from "./related-tools-rail"
export { CTABand } from "./cta-band"
export { ToolPageShell, type ToolPageShellProps } from "./tool-page-shell"
export { ToolProductRail, type ToolProduct } from "./tool-product-rail"
export { ToolProductCarousel } from "./tool-product-carousel"
export { ToolRecentlyViewedRail } from "./tool-recently-viewed-rail"
export { ToolShareBar } from "./tool-share-bar"
export { EditorialToc, type EditorialTocSection } from "./editorial-toc"

// Tool Page Building Blocks
export { CalcShell } from "./calc-shell"
export { BigResultBanner, type BigResultBannerStat } from "./big-result-banner"
export { VerdictCard, type VerdictTone, type VerdictReason } from "./verdict-card"
export { SignalPair, type SignalGroup } from "./signal-pair"
export {
  ToolPageTemplate,
  type ToolPageTemplateProps,
  type HeroStat,
  type HowItWorksFeature,
  type ConsiderationItem,
  type RelatedTool,
  type ExploreLink,
  type FAQItem,
  type SidebarInfoCard,
} from "./tool-page-template"

// Data Figures (render-time original imagery — inline SVG charts + spec table)
export {
  DataTrendChart,
  DataBarChart,
  SpecTableFigure,
  type TrendChartSeries,
  type BarDatum,
  type SpecRow,
} from "./data-figures"
